import { t } from "i18next";
import { Button, Modal } from "react-bootstrap";
import { deleteProgramFolder } from "../../../../services/program";

interface ProgramFolderDeleteProps {
    id: number;
    folderName: string;
    subfolders: { id: number; name: string }[];
    mediaFiles: { id: number; name: string }[];
    onDelete: CallableFunction;
    onClose: CallableFunction;
}

export function ProgramFolderDelete(props: ProgramFolderDeleteProps) {

    const handleDelete = (event: any) => {
        event.preventDefault();

        deleteProgramFolder(props.id)
            .then(response => {
                if (response.data.status == 1) {
                    props.onDelete(props.id);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
                alert(t("Error deleting folder"));
            });
    }

    const handleClose = () => {
        props.onClose();
    }

    const totalItems = props.subfolders.length + props.mediaFiles.length;
    const maxItemsToShow = 5;
    const hasMoreItems = totalItems > maxItemsToShow;

    return (
        <Modal className="folder-delete-container" show={ true }
            onHide={ handleClose }>
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("Delete folder") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>{ t("Are you sure you want to delete the folder") } <strong>{props.folderName}</strong>?</p>

                {totalItems > 0 && (
                    <div className="folder-content-warning">
                        <p className="warning-text">
                            <i className="bi bi-exclamation-triangle-fill"></i>
                            {" "}{t("This folder contains")}:
                        </p>
                        <ul className="content-list">
                            {props.subfolders.slice(0, maxItemsToShow).map(folder => (
                                <li key={`folder-${folder.id}`}>
                                    <i className="bi bi-folder2"></i> {folder.name}
                                </li>
                            ))}
                            {props.mediaFiles.slice(0, Math.max(0, maxItemsToShow - props.subfolders.length)).map(media => (
                                <li key={`media-${media.id}`}>
                                    <i className="bi bi-file-earmark"></i> {media.name}
                                </li>
                            ))}
                            {hasMoreItems && (
                                <li className="more-items">
                                    {t("and")} {totalItems - maxItemsToShow} {t("more items")}...
                                </li>
                            )}
                        </ul>
                    </div>
                )}

                <p className="danger-text">
                    <strong>{ t("All folders and files will be permanently deleted. This action cannot be undone.") }</strong>
                </p>

                <div className="actions">
                    <Button variant="danger" onClick={ handleDelete }>
                        { t("Delete permanently") }
                    </Button>
                    <Button variant="secondary" onClick={ handleClose }>
                        { t("Cancel") }
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
}
